// Generated by CoffeeScript 1.6.3
(function() {
  rjm.model.TimeFrame = Backbone.RelationalModel.extend({
    initialize: function(options) {
      var convertDateStringToDateObject;
      convertDateStringToDateObject = function(dateString) {
        var day, matchArray, month, pattern, year;
        if (dateString == null) {
          return null;
        }
        pattern = /(\d{4})-(\d{2})-(\d{2})/;
        matchArray = pattern.exec(dateString);
        year = matchArray[1];
        month = matchArray[2] - 1;
        day = matchArray[3];
        return new Date(year, month, day, 0, 0, 0, 0);
      };
      this.bindEnums();
      if (this.get("type") === rjm.app.enums.timeFrameType.SPECIFIC) {
        this.set({
          start: convertDateStringToDateObject(this.get("start")),
          end: convertDateStringToDateObject(this.get("end"))
        });
      }
      return this.bind("change:type", this.setDefaultTypeProperties);
    },
    convertRangeToDateObjects: function() {
      var end, start;
      switch (this.get("type")) {
        case rjm.app.enums.timeFrameType.MOVING:
          return {
            start: this._convertMovingToDateObject(this.get("includeInterval"), this.get("includePeriodCount")),
            end: this._convertMovingToDateObject(this.get("excludeInterval"), this.get("excludePeriodCount"))
          };
        case rjm.app.enums.timeFrameType.SPECIFIC:
          start = void 0;
          end = void 0;
          if (_(this.get("end")).isNull()) {
            end = new Date();
          } else {
            end = this.get("end");
          }
          if (_(this.get("start")).isNull()) {
            start = null;
          } else {
            start = this.get("start");
          }
          return {
            start: start,
            end: end
          };
        case rjm.app.enums.timeFrameType.ALL_TIME:
          return {
            start: null,
            end: new Date()
          };
      }
    },
    unbindEnumsFromAttributes: function(attributes) {
      attributes.type = attributes.type.serializedValue;
      if (attributes.includeInterval) {
        attributes.includeInterval = attributes.includeInterval.serializedValue;
      }
      if (attributes.excludeInterval) {
        attributes.excludeInterval = attributes.excludeInterval.serializedValue;
      }
      return attributes;
    },
    bindEnums: function() {
      this.set({
        type: rjm.app.enums.timeFrameType[this.get("type")]
      }, {
        silent: true
      });
      if (this.get("type") === rjm.app.enums.timeFrameType.MOVING) {
        this.set({
          includeInterval: rjm.app.enums.timeInterval[this.get("includeInterval")]
        }, {
          silent: true
        });
        if (this.get("excludeInterval")) {
          this.set({
            excludeInterval: rjm.app.enums.timeInterval[this.get("excludeInterval")]
          }, {
            silent: true
          });
        }
      }
      return this.change();
    },
    setDefaultTypeProperties: function() {
      var setDefaultEndDate, setDefaultStartDate;
      if (_(this.get("excludeInterval")).isUndefined()) {
        this.set({
          excludeInterval: rjm.app.enums.timeInterval.MONTH
        });
      }
      if (_(this.get("includeInterval")).isUndefined()) {
        this.set({
          includeInterval: rjm.app.enums.timeInterval.MONTH
        });
      }
      if (_(this.get("excludePeriodCount")).isUndefined()) {
        this.set({
          excludePeriodCount: 0
        });
      }
      if (_(this.get("includePeriodCount")).isUndefined()) {
        this.set({
          includePeriodCount: 12
        });
      }
      setDefaultStartDate = function(model) {
        return model.set({
          start: null
        });
      };
      setDefaultEndDate = function(model) {
        return model.set({
          end: null
        });
      };
      if (!this.has("start") && this.get("start") !== null) {
        setDefaultStartDate(this);
      }
      if (!this.has("end") && this.get("end") !== null) {
        setDefaultEndDate(this);
      }
      if (_(this.get("start")).isDate() && _(this.get("end")).isDate() && this.get("end") < this.get("start")) {
        setDefaultStartDate(this);
        return setDefaultEndDate(this);
      }
    },
    zeroPad: function(num, count) {
      var numZeropad;
      numZeropad = num + '';
      while (numZeropad.length < count) {
        numZeropad = "0" + numZeropad;
      }
      return numZeropad;
    },
    toJSON: function() {
      var convertDateObjToDateString, r,
        _this = this;
      r = Backbone.RelationalModel.prototype.toJSON.call(this);
      r = this.unbindEnumsFromAttributes(r);
      convertDateObjToDateString = function(dateObj) {
        var day, month, year;
        year = dateObj.getFullYear();
        month = _this.zeroPad(dateObj.getMonth() + 1, 2);
        day = _this.zeroPad(dateObj.getDate(), 2);
        return year + "-" + month + "-" + day;
      };
      r.start = _(r.start).isObject() ? convertDateObjToDateString(r.start) : void 0;
      r.end = _(r.end).isObject() ? convertDateObjToDateString(r.end) : void 0;
      return r;
    },
    getNumberOfSecondsInRange: function(minTime) {
      var dateObjects, _ref, _ref1;
      dateObjects = void 0;
      dateObjects = this.convertRangeToDateObjects();
      if (((_ref = dateObjects.start) != null ? _ref.toString() : void 0) === ((_ref1 = dateObjects.end) != null ? _ref1.toString() : void 0)) {
        return rjm.app.enums.timeInterval['DAY'].secondsInInterval;
      }
      if (dateObjects.start === null && (minTime != null)) {
        dateObjects.start = new Date(minTime);
      } else if (dateObjects.start === null && (minTime === null || minTime === void 0)) {
        return null;
      }
      return Math.round(dateObjects.end.getTime() / 1000) - Math.round(dateObjects.start.getTime() / 1000);
    },
    setDefaultGATimeOptions: function() {
      return this.set({
        excludeInterval: rjm.app.enums.timeInterval.YEAR,
        includeInterval: rjm.app.enums.timeInterval.YEAR,
        excludePeriodCount: 0,
        includePeriodCount: 2,
        type: rjm.app.enums.timeFrameType.MOVING
      }, {
        silent: true
      });
    },
    _convertMovingToDateObject: function(interval, count) {
      var current, currentMonth, quarterMonth, weekStartDayOffset;
      current = new Date();
      if (count === 0) {
        return current;
      }
      count--;
      switch (interval) {
        case rjm.app.enums.timeInterval.HOUR:
          return new Date(current.getFullYear(), current.getMonth(), current.getDate(), current.getHours() - count, 0, 0, 0);
        case rjm.app.enums.timeInterval.DAY:
          return new Date(current.getFullYear(), current.getMonth(), current.getDate() - count, 0, 0, 0, 0);
        case rjm.app.enums.timeInterval.WEEK:
          weekStartDayOffset = +this.get("weekStartDay") === 7 ? 0 : +this.get("weekStartDay");
          return new Date(current.getFullYear(), current.getMonth(), current.getDate() - current.getDay() + weekStartDayOffset - (count * 7), 0, 0, 0, 0);
        case rjm.app.enums.timeInterval.MONTH:
          return new Date(current.getFullYear(), current.getMonth() - count, 1, 0, 0, 0, 0);
        case rjm.app.enums.timeInterval.QUARTER:
          currentMonth = current.getMonth();
          quarterMonth = Math.floor(currentMonth / 3) * 3;
          return new Date(current.getFullYear(), quarterMonth - (count * 3), 1, 0, 0, 0, 0);
        case rjm.app.enums.timeInterval.YEAR:
          return new Date(current.getFullYear() - count, 0, 1, 0, 0, 0, 0);
        default:
          console.log(arguments_);
          throw "Invalid Arguments - convertRangeToDateObject";
      }
    }
  });

}).call(this);
